@let isChecked = this.checked();

<label class="group/Label toggle-checkbox-label"
    [class.is-checked]="isChecked"
    [class.label-first]="labelFirst()"
    [class.label-full-width]="labelFullWidth()">
  <input class="peer/CB toogle-checkbox-input"
      type="checkbox"
      [checked]="isChecked"
      [disabled]="disabled()"
      (click)="handleInputClick()"
      (change)="handleInteractionEvent($event)">
  <span class="toggle-checkbox-ui"></span>
  <div class="font-normal truncate w-full
              peer-checked/CB:font-bold
              peer-checked/CB:text-[--toggle-checkbox-color]
              peer-disabled/CB:!text-gray-600"
        [class.highlight]="highlightLabel()">
    <ng-content></ng-content>
  </div>
</label>
